<template>
  <div class="homeBox" v-show="showStatus" style="display: none;">
    <Header :colorType='colorType' :pageType='pageType' :productType='productType' class="header"></Header>
    <div class="content">
      <div class="top">
        <div class="top_left">
          <img src="../../assets/product/product/p3_1.png" class="img_big" v-if="active==1"/>
          <div class="img_box">
            <div class="img_icon_box">
              <img src="../../assets/plan/left.png" class="img_icon" @click="reduce(1)"/>
            </div>
            <div class="img_small_box">
              <img src="../../assets/product/product/p3_1.png" :class="['img_small', active==1?'img_small_active' : ''] " @click="changeImg(1)"/>
            </div>
            <div class="img_icon_box">
              <img src="../../assets/plan/right.png" class="img_icon" @click="add(1)"/>
            </div>
          </div>
        </div>
        <div class="top_right">
          <h3>任马停-智能收费一体机</h3>
          <h4>RMT500-2017-01</h4>
          <!-- <h5>￥19,272<span>/台</span></h5> -->
          <h5>￥7,500<span>/台</span></h5>
          <p>一体化嵌入式车牌识别一体机，集成车牌识别、LED显示、语音播报功能一体。</p>
          <div class="link" @click="link">查看智能停车收费控制机产品详情>></div>
        </div>
      </div>
      <div class="introduce">
        <h3>产品介绍</h3>
        <p>
          摄像头像素：500万<br>
          车辆号牌识别准确率率：≥99.9%<br>
          识别虚假车牌：能识别人员手持车牌、手机展示车牌照片、静态车辆图片等虚假车牌情况并过滤<br>
          <!-- 注：含设备施工、布线施工、水泥岛延岛施工、城市大脑及停车场物料、耗材等<br> -->
        </p>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/header/Header'
import Footer from '@/components/footer/Footer'
export default {
  name: 'Product1',
  data: function () {
    return {
      showStatus: false,
      colorType: '3',
      pageType: 'product',
      productType: 1,
      active: 1
    }
  },
  components: {
    Header,
    Footer
  },
  methods: {
    link() {
      this.$router.push('/Product1')
    },
    changeImg(active) {
      this.active=active
    },
    add (max) {
      if (this.active>=max) {
        this.active=1
      } else {
        this.active++
      }
    },
    reduce (max) {
      if (this.active<=1) {
        this.active=max
      } else {
        this.active--
      }
    },
  },
  mounted: function () {
    this.showStatus = true
  }
}
</script>

<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}
.header{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
}
.content{
  margin: 0 auto;
  margin-top: 160px;
  width: 1000px;
}

.top {
  width: 100%;
  display: flex;
  margin-top: 20px;
}
.top_left {
  width: 320px;
  margin-right: 50px;
}
.img_big {
  height: 320px;
}
.img_box {
  width: 320px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
}
.img_box .img_icon_box {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #eee;
  border-radius: 3px;
  width: 20px;
  height: 50px;
}
.img_icon_box .img_icon {
  width: 10px;
  cursor: pointer;
}
.img_small_box {
  flex: 1;
  display: flex;
  overflow: auto;
}
.img_small {
  width: 50px;
  height: 50px;
  object-fit: cover;
  margin: 0 10px;
  border-radius: 5px;
  cursor: pointer;
}
.img_small_active {
  border: 1px #333 solid;
}

.top_right {
  flex: 1;
  text-align: left;
  color: #333;
}
.top_right h3 {
  font-size: 24px;
}
.top_right h4 {
  font-size: 18px;
  margin: 10px 0;
}
.top_right h5 {
  font-size: 28px;
  margin: 20px 0;
  margin-bottom: 30px;
  color: red;
}
.top_right h5  span {
  font-size: 18px;
}
.top_right .link {
  color: #409EFF;
  margin-top: 30px;
  cursor: pointer;
}

.introduce {
  width: 100%;
  margin-top: 50px;
  margin-bottom: 50px;
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
  color: #333;
  text-align: left;
}
.introduce h3 {
  font-weight: bolder;
  font-size: 20px;
  margin-bottom: 20px;
}
.introduce p {
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/product/product3.vue